import axios from 'axios';
import { URL_GET_CONTACTS } from 'constants/urls';

const getContacts = async () => {
	const { data } = await axios({
		method: 'GET',
		url: URL_GET_CONTACTS,
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	});
	return data;
};

export default getContacts;
